import { useOnboarding } from '../../context/OnboardingContext';
import { applyStyles } from '../../utils/styleUtils';

const OptionsElement = ({ element }) => {
  const { replaceTemplates } = useOnboarding();
  const style = applyStyles(element);

  if (!element.items || !Array.isArray(element.items)) {
    return null;
  }

  return (
    <div className="element-options" style={style}>
      {element.items.map((item, index) => {
        let textValue = '';
        if (typeof item === 'string') {
          textValue = item;
        } else if (item && typeof item === 'object') {
          textValue = item.text || item.title || '';
        }

        return (
          <div key={index} className="option-item">
            <div className="option-icon">✓</div>
            <div className="option-text">
              {replaceTemplates(textValue)}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default OptionsElement;

